import { render } from "./AlertList.vue?vue&type=template&id=a6319dfa&scoped=true&ts=true"
import script from "./AlertList.vue?vue&type=script&lang=ts"
export * from "./AlertList.vue?vue&type=script&lang=ts"

import "./AlertList.vue?vue&type=style&index=0&id=a6319dfa&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6319dfa"]])

export default __exports__